<template>
  <!-- Sidebar (static, always visible) -->
  <aside class="w-56 bg-white border-r flex flex-col h-screen">
    <div class="flex-1 flex flex-col min-h-0">
      <nav class="p-3 flex-1 overflow-y-auto min-h-0">
        <div>
          <div class="text-xs font-semibold text-gray-400 mb-2">GENERAL</div>
          <ul class="space-y-1">
            <li v-for="link in sidebarLinks.general" :key="link.url">
              <div
                @click="toggleSubmenu(link)"
                :class="[
                  'flex items-center px-2 py-2 rounded-xl cursor-pointer',
                  isActive(link.url) ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-700 hover:bg-gray-100',
                ]"
              >
                <span class="material-icons mr-2.5 text-lg">{{ link.icon }}</span>
                {{ link.name }}
                <span v-if="link.submenu" class="material-icons ml-auto text-gray-400">{{
                  expandedMenu === link ? "expand_less" : "expand_more"
                }}</span>
              </div>
              <ul v-if="link.submenu && expandedMenu === link" class="pl-6 space-y-1">
                <li v-for="subLink in link.submenu" :key="subLink.url">
                  <div
                    @click="navigate(subLink.url)"
                    :class="[
                      'flex items-center px-2 py-2 rounded-xl cursor-pointer',
                      isActive(subLink.url) ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-700 hover:bg-gray-100',
                    ]"
                  >
                    {{ subLink.name }}
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="my-3 border-t"></div>
        <div>
          <div class="text-xs font-semibold text-gray-400 mb-2">OTHER SETTINGS</div>
          <ul class="space-y-1">
            <li v-for="link in sidebarLinks.support" :key="link.url">
              <div
                @click="toggleSubmenu(link)"
                :class="[
                  'flex items-center px-2 py-2 rounded-xl cursor-pointer',
                  isActive(link.url) ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-700 hover:bg-gray-100',
                ]"
              >
                <span class="material-icons mr-2.5 text-lg">{{ link.icon }}</span>
                {{ link.name }}
                <span v-if="link.submenu" class="material-icons ml-auto text-gray-400">{{
                  expandedMenu === link ? "expand_less" : "expand_more"
                }}</span>
              </div>
              <ul v-if="link.submenu && expandedMenu === link" class="pl-6 space-y-1">
                <li v-for="subLink in link.submenu" :key="subLink.url">
                  <div
                    @click="navigate(subLink.url)"
                    :class="[
                      'flex items-center px-2 py-2 rounded-xl cursor-pointer',
                      isActive(subLink.url) ? 'bg-gray-100 text-gray-900 font-medium' : 'text-gray-700 hover:bg-gray-100',
                    ]"
                  >
                    {{ subLink.name }}
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <!-- User Profile Section -->
    <div class="border-t p-2 b-gray-100">
      <!-- stays stuck at bottom -->
      <div class="flex items-center bg-white justify-center gap-2 px-2 py-2.5 rounded-lg shadowallthewayaround">
        <div class="w-12 h-9 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
          <img
            v-if="userData.image && !imageError"
            :src="userData.image"
            alt="User Avatar"
            class="w-full h-full object-cover"
            @error="imageError = true"
          />
          <span v-else class="material-icons">person</span>
        </div>
        <div class="flex w-full items-center justify-center">
          <div class="flex-col mr-2">
            <div class="font-semibold text-gray-800">
              {{ userData.name.length > 15 ? userData.name.slice(0, 15) + "..." : userData.name || "" }}
            </div>
            <div class="text-xs text-gray-500">{{ userData.email.length > 13 ? userData.email.slice(0, 13) + "..." : userData.email || "" }}</div>
          </div>
          <span
            class="material-icons text-gray-400 cursor-pointer bg-gray-200 hover:bg-gray-300 rounded-full p-1 select-none"
            @click="goToEditProfile"
          >
            edit
          </span>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "RedesignWrapper",
  props: {
    sidebarLinks: {
      type: Object,
      required: true,
    },
    userData: {
      type: Object,
      default: () => ({
        name: "",
        email: "",
        image: "",
      }),
    },
    editProfile: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      expandedMenu: null,
      debounceTimeout: null,
      imageError: false,
    };
  },
  methods: {
    goToEditProfile() {
      this.$router.push("/edit-profile");
    },
    watch: {
      "userData.image"(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.imageError = false;
        }
      },
    },
    async navigate(url) {
      if (this.$route.path !== url) {
        try {
          await this.$router.push(url);
        } catch (error) {
          if (error.name !== "NavigationDuplicated" && !error.message.includes("Navigation cancelled")) {
            console.error("Navigation error:", error);
          }
        }
      }
    },
    isActive(url) {
      if ((url === "/" && this.$route.path === "/dashboard") || (url === "/dashboard" && this.$route.path === "/")) {
        return true;
      }
      return this.$route.path === url;
    },
    toggleSubmenu(link) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        if (link.submenu) {
          this.expandedMenu = this.expandedMenu === link ? null : link;
        } else {
          this.navigate(link.url);
        }
      }, 100);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
.shadowallthewayaround {
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1), 0 0px 10px rgba(0, 0, 0, 0.1);
}
</style>
